import { ForgeProjectFeatureMessage } from "./SDKForgeProjectFeatureMessage";
import { ForgeProjectFeatureMessageReaction } from "./SDKForgeProjectFeatureMessageReaction";
export class ForgeProjectFeatureMessageList {
    constructor(model) {
        this.messages = model.messages.map((message) => new ForgeProjectFeatureMessage(message));
        this.reactions = model.reactions.map((reaction) => new ForgeProjectFeatureMessageReaction(reaction));
        this.lastSeenMessageId = model.lastSeenMessageId;
    }
    toRemote() {
        return {
            messages: this.messages.map((message) => message.toRemote()),
            reactions: this.reactions.map((reaction) => reaction.toRemote()),
            lastSeenMessageId: this.lastSeenMessageId,
        };
    }
}
